import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllBusiness = (
  page,
  size,
  order = "asc",
  filter = "averagemonthlysales"
) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.business + `?order=${filter}:${order}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page: page,
      size: size,
      // filters: filter,
      // order: order,
    },
  });
};

export const fetchBusinessDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.businessDetails(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchSellerBusinessDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerBusinessDetails(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchBuyerBusinesses = (
  page,
  size,
  order = "asc",
  filter = "averagemonthlysales"
) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.BuyerBusinessList + `?order=${filter}:${order}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page: page,
      size: size,
    },
  });
};

export const bookmarkBusiness = (isSaved, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.bookmarkBusiness(id),
    method: isSaved ? "delete" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const buyerInterestedinBusiness = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.interestBusiness(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteBusinessDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.businessDetails(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addBusinessData = (data, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url:
      id !== null ? config.routes.businessDetails(id) : config.routes.business,
    method: id !== null ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      address: data?.address,
      asking_price: parseInt(data?.askingPrice),
      assets_value: parseInt(data?.assetsValue),
      average_monthly_sales: parseInt(data?.ams),
      city: data?.city,
      contact_email: data?.contactEmail,
      contact_name: data?.contactName,
      country: data?.country,
      currency: {
        id: parseInt(data?.currency),
      },
      domain: data?.domain,
      ebitda: parseInt(data?.ebitda),
      email: data?.email,
      employees_number: parseInt(data?.employeesNo),
      equity_offered: parseInt(data?.equityOffered),
      established_at: data?.establishedAt,
      selling_deadline: data?.sellingDeadline,
      fax: data?.fax,
      name: data?.name,
      phone: data?.phone,
      phone2: data?.phone2,
      postal_code: data?.postalCode,
      region: data?.region,
      type: data?.type,
      website: data?.website,
      yearly_sales: parseInt(data?.yearlySales),
      description: data?.description,
      need_professional_help: data?.need_professional_help,
      professions_needed: data?.professions_needed,
      owners: data?.owners,
    },
  });
};

export const getAllbookmarkBusinesses = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getAllBookmarkedBusinesses,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getOffersRaisedBusinesses = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.offersRaisedBusinesses,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page: page,
      size: size,
    },
  });
};

export const getIncomeStatement = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.incomeStatement(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addIncomeStatement = (data, id, flag) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.incomeStatement(id),
    method: flag !== "add" ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      lastfiveyears:
        data?.length === 0
          ? data
          : data.map((item) => {
              delete item.open;
              delete item.id;
              return item;
            }),
    },
  });
};

export const deleteIncomeStatement = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.incomeStatement(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getIncomeStatementFile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.incomeStatementFile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
